export enum PillType {
  ENROLLMENT_STATUS = 'enrollment-status',
  FILE_STATUS = 'file-status',
  MSIS_REQUEST_STATUS = 'msis-request-status',
  USER_STATUS = 'user-status',
  CERTIFICATION_STATUS = 'certification-status',
}
